import { makeStyles } from "tss-react/mui";
import {
  IInspectionMenuAction,
  InspectionWorkListCard,
  MiBuildPageHeader,
  MiList,
} from "@miplatform/components";
import { Box } from "@mui/material";
import { useInspectionsContext } from "../InspectionsProvider";

export const InspectionList = ({
  loading,
  calendarName,
  onInspectionClick,
}: {
  loading: boolean;
  calendarName?: string;
  onInspectionClick?: (action: IInspectionMenuAction) => void;
}) => {
  const { classes, theme } = useStyles();

  const { inspectionList } = useInspectionsContext();

  return (
    <Box className={classes.inspectionListContainer}>
      <MiBuildPageHeader
        title={calendarName ?? "Inspections"}
        hasDivider={false}
        titleFontSize={theme.fontSize.xlarge}
        loading={loading}
      />
      <MiList
        viewType="card"
        data={inspectionList}
        CardComponent={InspectionWorkListCard}
        cardProps={{ onMenuItemClick: onInspectionClick }}
        loading={loading}
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  inspectionListContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: theme.spacing(0, 4),
  },
}));
